import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { getParsedParams } from "@faire/retailer-visitor-shared/components/Carousel/utils";
import { CarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { ILeanBrandTile } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/ILeanBrandTileAdapters";
import { LeanBrandTileRendererForCarousel } from "@faire/retailer-visitor-shared/components/LeanBrandTileRenderer/LeanBrandTileRendererForCarousel";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import * as React from "react";
export var BrandTileCarousel = function(props) {
    var CarouselBaseComponent = CarouselBase;
    var _React_useContext = React.useContext(Context), onItemClick = _React_useContext.onItemClick, requestId = _React_useContext.requestId, layoutElement = _React_useContext.layoutElement, onVisible = _React_useContext.onVisible;
    var _getParsedParams = getParsedParams(), refS = _getParsedParams.refS, refC = _getParsedParams.refC;
    var getItems = function() {
        var _layoutElement_layout_element_data;
        var layout_element_data = (_layoutElement_layout_element_data = layoutElement.layout_element_data) !== null && _layoutElement_layout_element_data !== void 0 ? _layoutElement_layout_element_data : [];
        if (props.filterItems !== undefined) {
            layout_element_data = layout_element_data.filter(props.filterItems);
        }
        return layout_element_data.map(function(layoutElementData) {
            return layoutElementData["brand_tile"];
        }).filter(isNotUndefined);
    };
    var renderBrandTileCarousel = function(brandTile, index) {
        var _leanBrandTile_brand;
        var leanBrandTile = ILeanBrandTile.fromIBrandTile(brandTile);
        var queryParamProps = props.brandPageQueryParams;
        var _leanBrandTile_brand_token;
        return /*#__PURE__*/ _jsx(LeanBrandTileRendererForCarousel, {
            onClick: function() {
                var _leanBrandTile_brand;
                var _layoutElement_on_click_event_name, _leanBrandTile_brand_token;
                onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick((_layoutElement_on_click_event_name = layoutElement.on_click_event_name) !== null && _layoutElement_on_click_event_name !== void 0 ? _layoutElement_on_click_event_name : "", requestId, (_leanBrandTile_brand_token = leanBrandTile === null || leanBrandTile === void 0 ? void 0 : (_leanBrandTile_brand = leanBrandTile.brand) === null || _leanBrandTile_brand === void 0 ? void 0 : _leanBrandTile_brand.token) !== null && _leanBrandTile_brand_token !== void 0 ? _leanBrandTile_brand_token : "");
            },
            leanBrandTile: leanBrandTile,
            showMinimum: props.showBrandMinimum,
            brandPageQueryParams: function(build) {
                return build({
                    refS: refS,
                    refC: refC !== null && refC !== void 0 ? refC : queryParamProps === null || queryParamProps === void 0 ? void 0 : queryParamProps.refC,
                    cat: queryParamProps === null || queryParamProps === void 0 ? void 0 : queryParamProps.cat
                });
            },
            signUpSourceId: "".concat(layoutElement.on_click_event_name, "_brand_tile_carousel")
        }, (_leanBrandTile_brand_token = leanBrandTile === null || leanBrandTile === void 0 ? void 0 : (_leanBrandTile_brand = leanBrandTile.brand) === null || _leanBrandTile_brand === void 0 ? void 0 : _leanBrandTile_brand.token) !== null && _leanBrandTile_brand_token !== void 0 ? _leanBrandTile_brand_token : index);
    };
    var onItemsVisible = function(items) {
        var itemTokens = items.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.token;
        });
        if (layoutElement.on_click_event_name) {
            var _itemTokens_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_itemTokens_join = itemTokens === null || itemTokens === void 0 ? void 0 : itemTokens.join(" ")) !== null && _itemTokens_join !== void 0 ? _itemTokens_join : "");
        }
    };
    return /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread({
        buttonsOffsetTop: "calc(50% - 20px)",
        renderItem: renderBrandTileCarousel,
        items: getItems(),
        onItemsVisible: onItemsVisible
    }, props));
};
